/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { PostUsersAuthMutationRequest, PostUsersAuthMutationResponse, PostUsersAuth400 } from '../entities/PostUsersAuth'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getPostUsersAuthUrl() {
  return `/users/auth` as const
}

/**
 * @description Аутентификация клиентов
 * @summary Аутентификация
 * {@link /users/auth}
 */
export async function postUsersAuth(
  data: PostUsersAuthMutationRequest,
  config: Partial<RequestConfig<PostUsersAuthMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<PostUsersAuthMutationResponse, ResponseErrorConfig<PostUsersAuth400>, PostUsersAuthMutationRequest>({
    method: 'POST',
    url: getPostUsersAuthUrl().toString(),
    data,
    ...requestConfig,
  })
  return res.data
}